export default "__VITE_ASSET__CuOFAZe3__"